<template>
    <div class="">
        <h1 class="title is-1">{{ $t('menu.homepage') }}</h1>
        <h2 class="title is-2">{{ $t('menu.news') }}</h2>
        <b-table class="news-table"
            :data="posts ? posts : []"
            :columns="columns"
            :loading="isLoading">
            <template slot-scope="props">
                <b-table-column field="message" label="Message">
                    <a :href="props.row.permalink_url" target="_blank">
                        {{ props.row.message }}
                    </a>
                </b-table-column>
                <b-table-column field="date" label="Date" width="40">
                    {{ props.row.updated_time.substring(0,10) }}
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>
<script>
    import axios from 'axios'

    export default {
        data(){
            return {
                isLoading: true,
                posts: [],
                columns: [
                    {
                        field: 'message',
                    },
                    {
                        field: 'date',
                    }
                ]
            }
        },
        methods: {
            getData(){
                axios.get("news.json")
                .then(response => {
                    this.isLoading = true
                    let iterator = 0;
                    response.data.data.forEach(element => {
                        if('message' in element && iterator < 4){
                            this.posts[iterator] = element;
                            if(element.message.length > 100){
                                this.posts[iterator].message = element.message.substring(0, 100)+'...';
                            }
                            iterator++;
                        }
                    });
                    this.isLoading = false
                })
            },
        },
        mounted(){
            this.getData()
        }
    }
//
</script>